import { assertNever } from "@impero-com/common/utils/obj";
import { Navigate, useParams } from "react-router-dom";

import { WebRoute } from "routes";

import { useEntityQuery } from "./queries/useEntityQuery";

/**
 * Routes to the appropriate entity view based on entity kind.
 * - Risk entities: redirects to /risk-entities/:id
 * - Control entities: renders children (ControlEntitiesEditPage)
 */
export function EntityRouter({ children }: { children: React.ReactNode }) {
    const { id } = useParams();
    if (!id) {
        throw new Error("Entity ID is required in the route parameters.");
    }
    const {
        data: {
            content: { resource: entity },
        },
    } = useEntityQuery(Number(id));

    switch (entity.kind) {
        case "Risk":
            return <Navigate to={`${WebRoute.RISK_ENTITIES}/${id}`} replace />;
        case "Control":
            return <>{children}</>;
        default:
            return assertNever(entity.kind);
    }
}
